import React from "react";
type PriceBlockProps = {
  inverse?: boolean;
  compact?: boolean;
  mobileCentered?: boolean;
  hidePaymentNote?: boolean;
};
export function PriceBlock({
  inverse = false,
  compact = false,
  mobileCentered = false,
  hidePaymentNote = false
}: PriceBlockProps) {
  const muted = inverse ? "text-[#a6bad8]" : "text-[#657189]";
  const strong = inverse ? "text-white" : "text-[#081a37]";
  const alignment = mobileCentered ? "text-center lg:text-left" : "";
  const priceAlignment = mobileCentered ? "justify-center lg:justify-start" : "";
  return <div className={alignment} data-id="element-250" data-mp="1g6ofo0oe3z8c">
      <p className="mb-1 text-xs font-extrabold tracking-[0.12em] text-[#07966b]" data-id="element-251" data-mp="1tvyppb5jkb89">50% OFF</p>
      <div className={`flex items-end gap-3 ${priceAlignment}`} data-id="element-252" data-mp="1p5icns5murmf">
        <span className={`mb-1 text-sm font-semibold line-through ${muted}`} data-id="element-253" data-mp="1p479nuk0hnwd">$39.980 ARS</span>
        <span className={`font-extrabold tracking-[-0.06em] ${compact ? "text-4xl" : "text-5xl sm:text-6xl"} ${strong}`} data-id="element-254" data-mp="11e4irhru2nzc">$19.990</span>
        <span className={`mb-1.5 text-sm font-bold ${muted}`} data-id="element-255" data-mp="1rzrjlozfwgxy">ARS</span>
      </div>
      {!hidePaymentNote && <p className={`mt-1 text-sm font-medium ${muted}`} data-id="element-256" data-mp="1wykztp642m1t">Pago único · Sin suscripciones</p>}
    </div>;
}